<template>
  <div class="question-container mb-3">
    <label :class="[customClass, 'label-id-' + question.id]">
      <span v-if="question.number">{{ question.number }}.</span>
      <span v-html="formattedQuestion"></span>
    </label>
    <small
      v-if="question?.['question-options']?.small"
      class="small"
      style="white-space: nowrap;"
    >
      {{ question?.['question-options']?.small }}
    </small>
  </div>
</template>


<script>
export default {
  props: {
    question: Object,
    customClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    formattedQuestion() {
      // Replace text inside '&...&' with bold formatting
      return this.question.question.replace(/&(.*?)&/g, "<b>$1</b>");
    }
  }
};
</script>

<style>
.label-id-11 {
  font-weight: 600 !important;
  color: #000;
}
</style>
